var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreaseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.335,
    height: 9.417,
    viewBox: "0 0 7.335 9.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Arrow_1920802",
    transform: "translate(53.667 54.708) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M16.033,2.768,13.268,5.523A.9.9,0,0,0,14.546,6.8l1.219-1.219v5.432a.9.9,0,1,0,1.8,0V5.583L18.789,6.8a.907.907,0,0,0,1.546-.634.961.961,0,0,0-.268-.644L17.3,2.768a.886.886,0,0,0-1.269,0Z",
    transform: "translate(33.333 42.792)",
    fill: "#f42929"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseArrow);
export default __webpack_public_path__ + "static/media/decreaseArrow.15c119cb8d44f97e6125f2c6ae5934d3.svg";
export { ForwardRef as ReactComponent };